module.exports = __webpack_public_path__ + "media/images/down-arrow-circle-96b972c8.png";